import { useState } from "react";
import Button from "src/components/ui-kit/Button/Button";
import useLocalization from 'src/services/localization/useLocalization';
import { styles } from './Truncate.styles';

interface Props {
  text: string;
  maxLength: number;
}

const Truncate = ({ text, maxLength }: Props) => {
  const withoutHtmlTags = text.replace(/(<([^>]+)>)/gi, '');
  const textShouldBeTruncated = withoutHtmlTags.length > maxLength;
  const [isTruncated, setIsTruncated] = useState(textShouldBeTruncated);
  const localize = useLocalization();
  const ellipsis = '...';

  const toggleTruncate = () => {
    setIsTruncated(!isTruncated);
  };

  const truncatedText = isTruncated ? `${withoutHtmlTags.slice(0, maxLength - ellipsis.length)}${ellipsis}` : text;
  const buttonDataMarker = isTruncated ? 'show more' : 'show less';

  return (
    <div className="Truncate">
      <p className="Truncate__content" dangerouslySetInnerHTML={{ __html: truncatedText }} />
      {textShouldBeTruncated && (
        <Button onClick={toggleTruncate} variant="ghost" dataMarkerValue={buttonDataMarker} regularText>
          {localize(isTruncated ? 'products.show-more' : 'products.show-less')}
        </Button>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

export default Truncate;
